module.exports = "images/get-inspired-7.jpg";